import { Button } from "primereact/button";
import React, { Component } from "react";
import { Card } from "primereact/card";
import { withContext } from "../shared/withContext";
import { ContextIF } from "../../App";
import { withRouter } from "react-router";
import { startStripeSession } from "../../logik/apiCalls";
interface Props {
    context: ContextIF;
    history: any;
}
interface State {
    loading: boolean;
}

class Pricing extends Component<Props, State> {
    state = {
        loading: false,
    };
    render() {
        return (
            <Card>
                <br></br>
                Jetzt zur Vollversion wechseln und Zugriff auf alle Funktionen
                bekommen - für nur <b>4,90€ / Jahr</b>!<br></br>
                <br />
                <b>Stimmfix</b>, bedienungsfreundliche Stimmgerät für alle
                Tischharfen:
                <ul>
                    <li>Harmonieharfe (25 Saiten)</li>
                    <li>Veeh-Harfe (25 Saiten)</li>
                    <li>Veeh-Harfe (37 Saiten)</li>
                    <li>Veeh-Harfe (18 Saiten)</li>
                    <li>Zauberharfe (25 Saiten)</li>
                    <li>Zauberharfe (21 Saiten)</li>
                </ul>
                <br />
                Das Abbonement kann jederzeit gekündigt werden.
                <br />
                {!this.props.context.authenticated && (
                    <Button
                        label="Jetzt anmelden"
                        onClick={() => {
                            this.props.history.push("/login");
                        }}
                    ></Button>
                )}
                {this.props.context.authenticated &&
                    !this.props.context.hasPremium && (
                        <Button
                            label="Jetzt abonnieren"
                            icon="pi pi-star"
                            loading={this.state.loading}
                            onClick={() => {
                                this.setState({ loading: true });

                                if ("getDigitalGoodsService" in window) {
                                    // Digital Goods API is supported!
                                } else {
                                    startStripeSession(
                                        "price_1LjMg7ARrsSEnK5qRWyIQVBv"
                                    );
                                }
                            }}
                        ></Button>
                    )}
                {this.props.context.authenticated &&
                    this.props.context.hasPremium && (
                        <Button
                            loading={this.state.loading}
                            label="Abonnement Verwalten"
                            onClick={() => {
                                this.setState({ loading: true });
                                startStripeSession(
                                    "price_1LjMg7ARrsSEnK5qRWyIQVBv"
                                );
                            }}
                        ></Button>
                    )}
            </Card>
        );
    }
}

export default withRouter(withContext(Pricing));
